/* Vettepet: winkelmandje openen na toevoegen, verzendbalk en upsell */
(function () {
  if (window.__vpCart) return;
  window.__vpCart = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var internalAdd = false;
  var lastOpen = 0;

  function euro(cents) {
    return '\u20ac' + (Math.max(cents, 0) / 100).toFixed(2).replace('.', ',');
  }
  function drawer() { return document.querySelector('.side-cart'); }
  function isOpen() {
    var d = drawer();
    if (!d) return false;
    var cs = getComputedStyle(d);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) return false;
    var r = d.getBoundingClientRect();
    return r.width > 0 && r.left < window.innerWidth - 4 && r.right > 4;
  }
  function openDrawer() {
    var now = Date.now();
    if (now - lastOpen < 1200) return;
    lastOpen = now;
    setTimeout(function () {
      if (isOpen()) return;
      var t = document.querySelector('.section-header .icon-cart[data-action="toggle-cart"]') ||
              document.querySelector('[data-action="toggle-cart"]:not(.close)');
      if (t) t.click();
    }, 200);
  }

  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ---------- Verzendbalk ---------- */
  function updateBars(cart) {
    var bars = document.querySelectorAll('.vp-shipbar');
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      var t1 = parseInt(b.getAttribute('data-t1'), 10) || 4900;
      var t2 = parseInt(b.getAttribute('data-t2'), 10) || 7500;
      var total = cart.total_price || 0;
      var msg;
      if (total < t1) msg = b.getAttribute('data-s-pickup').replace('{amount}', euro(t1 - total));
      else if (total < t2) msg = b.getAttribute('data-s-home').replace('{amount}', euro(t2 - total));
      else msg = b.getAttribute('data-s-done');
      var m = b.querySelector('.vp-shipbar__msg');
      if (m) m.innerHTML = msg;
      var f = b.querySelector('.vp-shipbar__fill');
      if (f) f.style.width = Math.min(100, total / t2 * 100) + '%';
      b.classList.toggle('got-pickup', total >= t1);
      b.classList.toggle('got-home', total >= t2);
      if (b.hasAttribute('data-hide-empty')) b.classList.toggle('is-empty', !cart.item_count);
    }
  }

  /* ---------- Upsell ---------- */
  var upsell = null;
  var upsellData = [];
  try {
    var raw = document.getElementById('vp-upsell-data');
    if (raw) upsellData = JSON.parse(raw.textContent).filter(Boolean);
  } catch (e) { upsellData = []; }

  function currentProductId() {
    try { return window.ShopifyAnalytics.meta.product.id; } catch (e) { return null; }
  }

  function renderUpsell(cart) {
    upsell = upsell || document.querySelector('.vp-upsell');
    if (!upsell || !upsellData.length) return;
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.product_id] = true; });
    var cur = currentProductId();
    var list = upsellData.filter(function (p) { return !inCart[p.id] && p.id !== cur; }).slice(0, 4);
    if (!list.length) { upsell.hidden = true; return; }

    var title = upsell.getAttribute('data-title');
    var total = cart.total_price || 0;
    if (upsell.getAttribute('data-be') === '1' && total > 0 && total < 4900) {
      title = upsell.getAttribute('data-gap').replace('{amount}', euro(4900 - total));
    }
    upsell.querySelector('.vp-upsell__title').textContent = title;

    var addTxt = upsell.getAttribute('data-add');
    var html = '';
    list.forEach(function (p) {
      html += '<div class="vp-upsell__card">' +
        '<a class="vp-upsell__img" href="' + p.u + '"><img src="' + p.i + '" alt="" width="120" height="120"></a>' +
        '<a class="vp-upsell__name" href="' + p.u + '"></a>' +
        '<div class="vp-upsell__price">' + (p.c ? '<s>' + p.c + '</s> ' : '') + p.p + '</div>' +
        '<button type="button" class="vp-upsell__add" data-v="' + p.v + '">' + addTxt + '</button>' +
        '</div>';
    });
    var track = upsell.querySelector('.vp-upsell__track');
    track.innerHTML = html;
    var names = track.querySelectorAll('.vp-upsell__name');
    list.forEach(function (p, i) { names[i].textContent = p.t; });
    placeUpsell();
    upsell.hidden = !document.querySelector('.side-cart .side-cart-container .items');
  }

  var placing = false;
  function placeUpsell() {
    if (placing) return;
    placing = true;
    try {
      var c = document.querySelector('.side-cart .side-cart-container');
      if (!c) return;
      var items = c.querySelector('.items');
      var form = c.querySelector('form');
      /* Verzendbalk bovenaan de lijst, in de normale flow */
      var bar = document.querySelector('.vp-drawer-bar');
      if (bar) {
        var bTarget = items || form || c;
        if (bar.parentNode !== bTarget || bTarget.firstElementChild !== bar) bTarget.insertBefore(bar, bTarget.firstChild);
        bar.hidden = false;
      }
      /* Upsell onderaan de lijst met producten */
      upsell = upsell || document.querySelector('.vp-upsell');
      if (upsell && items) {
        if (upsell.parentNode !== items || items.lastElementChild !== upsell) items.appendChild(upsell);
      } else if (upsell && upsell.parentNode !== document.body) {
        document.body.appendChild(upsell);
        upsell.hidden = true;
      }
    } finally {
      placing = false;
    }
  }

  function refreshTheme() {
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') { window.ajaxCart.load(); return; }
    var q = document.querySelector('.side-cart .ajaxcart__qty-num');
    if (q) {
      q.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    try { sessionStorage.setItem('vpOpenCart', '1'); } catch (e) {}
    window.location.reload();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.vp-upsell__add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    btn.disabled = true;
    internalAdd = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-v'), 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      btn.textContent = upsell.getAttribute('data-added');
      refreshTheme();
      schedule();
    }).catch(function () {
      btn.disabled = false;
    }).then(function () {
      setTimeout(function () { internalAdd = false; }, 800);
    });
  }, true);

  /* ---------- Cart-wijzigingen opvangen ---------- */
  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      getCart().then(function (cart) {
        updateBars(cart);
        renderUpsell(cart);
        var counts = document.querySelectorAll('.cart-count');
        for (var i = 0; i < counts.length; i++) {
          counts[i].textContent = cart.item_count;
          counts[i].classList.toggle('hidden-count', !cart.item_count);
        }
      }).catch(function () {});
    }, 250);
  }

  function onCartRequest(url, status) {
    if (!url || status >= 400) return;
    url = String(url);
    if (/\/cart\/add/.test(url)) {
      if (!internalAdd) openDrawer();
      schedule();
    } else if (/\/cart\/(change|update|clear)/.test(url)) {
      schedule();
    }
  }

  var xOpen = XMLHttpRequest.prototype.open;
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__vpUrl = u; return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    x.addEventListener('load', function () { onCartRequest(x.__vpUrl, x.status); });
    return xSend.apply(this, arguments);
  };
  if (window.fetch) {
    var oFetch = window.fetch;
    window.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      return oFetch.apply(this, arguments).then(function (r) { onCartRequest(u, r.status); return r; });
    };
  }

  /* Vangnet: stijgt het aantal in het mandje, open dan de lade */
  function watchCount() {
    var el = document.querySelector('.section-header .cart-count');
    if (!el || !window.MutationObserver) return;
    var prev = parseInt(el.textContent, 10) || 0;
    new MutationObserver(function () {
      var now = parseInt(el.textContent, 10) || 0;
      if (now > prev && !internalAdd) { openDrawer(); schedule(); }
      prev = now;
    }).observe(el, { childList: true, characterData: true, subtree: true });
  }

  function watchDrawer() {
    var c = document.querySelector('.side-cart .side-cart-container');
    if (!c || !window.MutationObserver) return;
    new MutationObserver(function () { if (!placing) placeUpsell(); }).observe(c, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-action="toggle-cart"]');
    if (t) schedule();
  });

  function init() {
    watchCount();
    watchDrawer();
    placeUpsell();
    schedule();
    try {
      if (sessionStorage.getItem('vpOpenCart')) {
        sessionStorage.removeItem('vpOpenCart');
        setTimeout(openDrawer, 500);
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
